<template>
  <div :class="$style.localeContainer">
    <div :class="$style.localeSelector" @click="toggleOpen">
      <span :class="[$style.flag, currentOption.flagClass]"></span>
      <span :class="$style.code">{{ currentOption.label }}</span>
      <span :class="$style.caret">▾</span>
    </div>

    <div v-if="open" :class="$style.localeMenu">
      <div
        v-for="opt in options"
        :key="opt.value"
        :class="$style.localeOption"
        @click="selectLocale(opt)"
      >
        <span :class="[$style.flag, opt.flagClass]"></span>
        <span :class="$style.code">{{ opt.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import styles from "@/css/HeaderLanguageSelector.module.css";

const $style = styles;
const { locale } = useI18n(); // reactive ref from vue-i18n

const open = ref(false);

const options = [
  { value: "en",   label: "EN", flagClass: "fi fi-us" },
  { value: "serb", label: "SR", flagClass: "fi fi-rs" },
  { value: "tr",   label: "TR", flagClass: "fi fi-tr" },
];

const currentOption = computed(
  () => options.find((o) => o.value === locale.value) || options[0]
);

function toggleOpen() {
  open.value = !open.value;
}

function selectLocale(opt) {
  locale.value = opt.value;
  open.value = false;
}
</script>
